<div class="container-fluid">
  <div class="row">
    <!-- Lista de Clientes -->
    <div class="col-md-4">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Clientes</h4>
          <div class="input-group mt-2">
            <input type="text" 
                   class="form-control" 
                   placeholder="Buscar por nome..." 
                   [(ngModel)]="termoBusca" 
                   (keyup.enter)="buscarClientes()"
                   name="termoBusca">
            <div class="input-group-append">
              <button class="btn btn-primary" type="button" (click)="buscarClientes()">
                <i class="feather icon-search"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="card-body p-0">
          <div class="list-group list-group-flush">
            <div *ngIf="clientes.length === 0" class="p-3 text-center text-muted">
              Nenhum cliente encontrado
            </div>
            <a *ngFor="let cliente of clientes" 
               href="javascript:void(0)" 
               class="list-group-item list-group-item-action"
               [class.active]="clienteSelecionado?.id === cliente.id"
               (click)="selecionarCliente(cliente)">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h6 class="mb-0">{{ cliente.nome }}</h6>
                  <small class="text-muted">CNPJ: {{ cliente.cnpj }}</small>
                  <br>
                  <small class="text-muted">Cadastro: {{ cliente.dataCadastro | date:'dd/MM/yyyy' }}</small>
                </div>
                <span class="badge" [ngClass]="cliente.empresaGestora ? 'badge-primary' : 'badge-secondary'">
                  {{ cliente.empresaGestora ? 'Gestora' : 'Cliente' }}
                </span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Cronogramas do Cliente -->
    <div class="col-md-8" *ngIf="clienteSelecionado">
      <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h4 class="card-title mb-0">Cronogramas de {{ clienteSelecionado.nome }}</h4>
          <button class="btn btn-sm btn-primary" (click)="abrirModalVincular(modalVincular)">
            <i class="feather icon-plus"></i> Vincular Cronograma
          </button>
        </div>
        <div class="card-body">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>ID</th>
                <th>Cronograma Base</th>
                <th>Data Cadastro</th>
                <th>Data Início</th>
                <th>Data Fim</th>
                <!--<th>Status</th>-->
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let cronograma of cronogramasCliente">
                <td>{{ cronograma.id }}</td>
                <td>{{ cronograma.nome }}</td>
                <td>{{ cronograma.dataCadastro | date:'dd/MM/yyyy' }}</td>
                <td>{{ cronograma.inicio | date:'dd/MM/yyyy' }}</td>
                <td>{{ cronograma.fim | date:'dd/MM/yyyy' }}</td>
                <!--<td>
                  <span class="badge" [ngClass]="cronograma.status === 'Ativo' ? 'badge-success' : 'badge-danger'">
                    {{ cronograma.status }}
                  </span>
                </td>-->
                <td>
                  <!--<button class="btn btn-sm" 
                          [ngClass]="cronograma.status === 'Ativo' ? 'btn-danger' : 'btn-success'"
                          (click)="alterarStatus(cronograma)">
                    {{ cronograma.status === 'Ativo' ? 'Inativar' : 'Ativar' }}
                  </button>-->
                  <button class="btn btn-sm btn-info ml-2" 
                          (click)="abrirModalItensCronogramaBase(modalItensCronogramaBase, cronograma); $event.stopPropagation()">
                    <i class="feather icon-list"></i> Ver Itens
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Vincular Cronograma -->
<ng-template #modalVincular>
  <div class="modal-header">
    <h5 class="modal-title">Vincular Cronograma</h5>
    <button type="button" class="close" (click)="modalService.dismissAll()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="vincularForm" (ngSubmit)="vincularCronograma()">
      <div class="form-group">
        <label>Cronograma Base</label>
        <select class="form-control" formControlName="idCronogramaBase">
          <option value="">Selecione um cronograma</option>
          <option *ngFor="let cronograma of cronogramasBase" [value]="cronograma.id">
            {{ cronograma.nome }} (Criado em: {{ cronograma.dataCriacao | date:'dd/MM/yyyy' }})
          </option>
        </select>
        <div class="invalid-feedback" *ngIf="vincularForm.get('idCronogramaBase').invalid && vincularForm.get('idCronogramaBase').touched">
          Por favor, selecione um cronograma.
        </div>
        <div class="text-muted small mt-1" *ngIf="cronogramasBase.length === 0">
          Nenhum cronograma base disponível.
        </div>
      </div>
      <div class="form-group">
        <label>Data de Início</label>
        <input type="date" class="form-control" formControlName="dataInicio">
      </div>
      <div class="form-group">
        <label>Data de Fim</label>
        <input type="date" class="form-control" formControlName="dataFim">
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="vincularCronograma()" [disabled]="!vincularForm.valid">
      Vincular
    </button>
  </div>
</ng-template>

<!-- Modal Itens do Cronograma Base -->
<ng-template #modalItensCronogramaBase>
  <div class="modal-header">
    <h5 class="modal-title">Itens do Cronograma Base: {{ cronogramaBaseSelecionado?.nome }}</h5>
    <button type="button" class="close" (click)="modalService.dismissAll()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="table-responsive">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Ordem</th>
            <th>Nome</th>
            <th>Descrição</th>
            <th>Prazo (dias)</th>
            <th>Data Início</th>
            <th>Data Fim</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of itensCronogramaBase">
            <td>{{ item.ordem }}</td>
            <td>{{ item.nome }}</td>
            <td>{{ item.descricao }}</td>
            <td>{{ item.prazoEmDias }}</td>
            <td>
              <input type="date" 
                     class="form-control form-control-sm" 
                     [value]="item.dataInicio ? (item.dataInicio | date:'yyyy-MM-dd') : ''"
                     (change)="alterarDataInicioItem(item, $event.target.value)">
            </td>
            <td>
              <input type="date" 
                     class="form-control form-control-sm" 
                     [value]="item.dataFim ? (item.dataFim | date:'yyyy-MM-dd') : ''"
                     (change)="alterarDataFimItem(item, $event.target.value)">
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Fechar</button>
    <button type="button" class="btn btn-primary" (click)="salvarAlteracoesItens()" [disabled]="!itensCronogramaBase.length">
      <i class="feather icon-save"></i> Salvar Alterações
    </button>
  </div>
</ng-template> 